import apiClient from './apiClient';

const analyticsService = {
  // Get all product views with pagination and filtering
  getProductViews: async (params = {}) => {
    const response = await apiClient.get('/analytics/products/views', { params });
    return response.data;
  },

  // Get detailed statistics for a specific product
  getProductStats: async (productId) => {
    const response = await apiClient.get(`/analytics/products/${productId}/views`);
    return response.data;
  },

  // Get detailed stats for a product (views, downloads, wishlists, orders)
  getProductDetailedStats: async (productId, period = 30) => {
    const params = period === 'all' ? {} : { period };
    const response = await apiClient.get(`/analytics/products/${productId}/detailed-stats`, { params });
    return response.data;
  },

  // Get product views with user details
  getProductViewsWithUsers: async (productId, limit = 50, days = null, page = 1, perPage = 5) => {
    const params = { limit, page, per_page: perPage };
    if (days) params.days = days;
    const response = await apiClient.get(`/analytics/products/${productId}/views-with-users`, { params });
    return response.data.data || response.data; // Handle both paginated and non-paginated responses
  },

  // Get product downloads with user details
  getProductDownloadsWithUsers: async (productId, page = 1, perPage = 5) => {
    const params = { page, per_page: perPage };
    const response = await apiClient.get(`/analytics/products/${productId}/downloads-with-users`, { params });
    return response.data.data || response.data; // Handle both paginated and non-paginated responses
  },

  // Get product wishlists with user details
  getProductWishlistsWithUsers: async (productId, page = 1, perPage = 5) => {
    const params = { page, per_page: perPage };
    const response = await apiClient.get(`/analytics/products/${productId}/wishlists-with-users`, { params });
    return response.data.data || response.data; // Handle both paginated and non-paginated responses
  },

  // Get product orders with user details
  getProductOrdersWithUsers: async (productId, page = 1, perPage = 5) => {
    const params = { page, per_page: perPage };
    const response = await apiClient.get(`/analytics/products/${productId}/orders-with-users`, { params });
    return response.data.data || response.data; // Handle both paginated and non-paginated responses
  },

  // Get trending products
  getTrendingProducts: async (days = 7, limit = 10) => {
    const response = await apiClient.get('/analytics/products/trending', {
      params: { days, limit }
    });
    return response.data;
  },

  // Get trending products scoped to vendor(s) for sellers
  getTrendingProductsForVendor: async (days = 7, limit = 10) => {
    const response = await apiClient.get('/analytics/products/trending/vendor', {
      params: { days, limit }
    });
    return response.data;
  },

  // Get most viewed products (all time)
  getMostViewedProducts: async (limit = 10) => {
    const response = await apiClient.get('/analytics/products/most-viewed', {
      params: { limit }
    });
    return response.data;
  },

  // Get most viewed products scoped to vendor(s) for sellers
  getMostViewedProductsForVendor: async (limit = 10) => {
    const response = await apiClient.get('/analytics/products/most-viewed/vendor', {
      params: { limit }
    });
    return response.data;
  },

  // Get user view history
  getUserViewHistory: async (userId, limit = 20) => {
    const response = await apiClient.get(`/analytics/users/${userId}/view-history`, {
      params: { limit }
    });
    return response.data;
  },

  // Get analytics dashboard overview (admin only)
  getDashboardOverview: async (period = 30) => {
    const response = await apiClient.get('/analytics/dashboard/overview', {
      params: { period }
    });
    return response.data;
  },

  // Get analytics dashboard overview scoped to seller's vendors
  getDashboardOverviewForVendor: async (period = 30) => {
    const response = await apiClient.get('/analytics/dashboard/overview/vendor', {
      params: { period }
    });
    return response.data;
  },

  // Compare multiple products
  compareProducts: async (productIds, days = 30) => {
    const response = await apiClient.post('/analytics/products/comparison', {
      product_ids: productIds,
      days
    });
    return response.data;
  }
};

export default analyticsService;
